import { Util } from 'utils/common.utils';
import styles from './carousel-item.module.scss';

function CarouselItem({
  title,
  text,
  image,
  magnifiedImg,
  magnifiedImg2,
  ltr,
}: {
  title: string;
  text: string;
  image: string;
  magnifiedImg: string;
  magnifiedImg2?: string;
  ltr: boolean;
}) {
  return (
    <div className={styles.mainContainer}>
      <div className={'w-100 text-center cust-pr-sm-6 cust-pl-sm-6 cust-pb-4 cust-pt-1'}>
        <h3 className={`text-light m-auto  cust-pb-2 ${styles.title}`}>{title}</h3>
        <p className="text-light text-center text-regular">{text}</p>
      </div>
      <img src={Util.GetImageAsset(image)} alt={image} className={ltr ? styles.imageRight : styles.imageLeft}></img>
      <img
        src={Util.GetImageAsset(magnifiedImg)}
        alt={magnifiedImg}
        className={ltr ? styles.magnifiedImg : styles.magnifiedImgRight}
      ></img>
      {magnifiedImg2 && (
        <img src={Util.GetImageAsset(magnifiedImg2)} alt={magnifiedImg2} className={styles.magnifiedImg2}></img>
      )}
    </div>
  );
}

export default CarouselItem;